module.exports = __webpack_public_path__ + "public/1.0.1_301066/img/submitFinish.3d4488e3.jpeg";